import React from 'react';
export function SchemaMarkup() {
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'ai.web - Website Design Ireland',
    image: 'https://aiwebsitepackage.com/og-image.jpg',
    description: 'Affordable professional website design for Irish small businesses. €249 launch package including hosting, support, and AI editing.',
    priceRange: '€249',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Dublin',
      addressCountry: 'IE'
    },
    areaServed: [{
      '@type': 'City',
      name: 'Dublin'
    }, {
      '@type': 'Country',
      name: 'Ireland'
    }],
    url: 'https://aiwebsitepackage.com',
    telephone: '+353870000000',
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00'
    }
  };
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'Website Design',
    provider: {
      '@type': 'LocalBusiness',
      name: 'ai.web'
    },
    areaServed: {
      '@type': 'Country',
      name: 'Ireland'
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Website Design Packages',
      itemListElement: [{
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Dublin Launch Package'
        },
        price: '249.00',
        priceCurrency: 'EUR'
      }]
    }
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'How much does website design cost in Ireland?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Most agencies charge €2,000–€5,000+ for a standard business website. Freelancers range from €800–€2,000. Our launch package is €249 one-time because we use AI-powered tools that let us build professional sites faster and pass the savings to you. This includes a custom design, mobile responsiveness, SEO setup, 1 year of hosting, and direct support. There are no hidden fees or monthly charges.'
      }
    }, {
      '@type': 'Question',
      name: 'How long does it take to launch my website?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Most websites are ready within 48–72 hours after we receive your content (text, images, logo). If you need help writing copy or sourcing images, we can guide you through the process. The faster you provide materials, the faster we deliver. Rush delivery is also available if you need your site live urgently.'
      }
    }, {
      '@type': 'Question',
      name: 'Will my site rank on Google?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Every website we build includes an SEO-friendly structure with proper heading hierarchy, fast loading speeds, mobile responsiveness, and clean code — all key ranking factors for Google Ireland. We also set up basic on-page SEO including meta titles, descriptions, and alt text. For businesses targeting local searches like "electrician Dublin" or "restaurant near me", our structure gives you a strong foundation to rank.'
      }
    }, {
      '@type': 'Question',
      name: 'Do I need hosting?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'No need to worry about hosting — 1 full year of fast, reliable hosting is included in every package at no extra cost. After the first year, hosting renewal is available at an affordable rate. We handle all the technical setup so you can focus on running your business.'
      }
    }, {
      '@type': 'Question',
      name: 'Can you redesign an existing site?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Absolutely. If you already have a website that looks outdated or isn't converting visitors into customers, we can rebuild it from scratch with a modern, professional design. We'll keep your existing domain and can migrate any content you want to preserve. The result is a faster, better-looking site that works harder for your business."
      }
    }, {
      '@type': 'Question',
      name: 'What support comes with the service?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Every package includes 1 year of direct support via WhatsApp and LINE. You can reach us for help with content updates, technical questions, or guidance on using the AI editing tools. We also include 100 AI editing requests per month so you can make changes to your site without needing a developer. We typically respond within a few hours.'
      }
    }]
  };
  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Affordable Website Design Ireland | Web Design Dublin — From €249',
    description: 'Professional website design Ireland for small businesses. One-time price, AI editable, hosting + support included. Rank on Google & get customers.',
    url: 'https://aiwebsitepackage.com'
  };
  return <div style={{
    display: 'none'
  }} data-id="element-598">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(localBusinessSchema)
    }} data-id="element-599" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(serviceSchema)
    }} data-id="element-600" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-601" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(webPageSchema)
    }} data-id="element-602" />
    </div>;
}